import currency from "currency.js";
import { useTranslation } from "react-i18next";
import useIndexWSS from "../../../hooks/wss/useIndexWSS";
import Stat from "../Stat";

interface IIndexPriceStatProps {
  precision: number;
  asset?: string;
}

function IndexPriceStat({ precision, asset }: IIndexPriceStatProps) {
  const { t } = useTranslation("app", {
    keyPrefix: "TradingHeader.PerpsTradingHeader",
  });

  const { index } = useIndexWSS(asset);

  return (
    <Stat
      label={t("index_price")}
      value={
        index?.price
          ? `${currency(index.price, {
              precision: precision ?? 2,
            }).format()}`
          : "-"
      }
    />
  );
}

export default IndexPriceStat;
